"use client";
import React from 'react';
import Link from 'next/link';
import { usePathname as useLocation } from 'next/navigation';

import { Settings, Edit3, Plus, LayoutDashboard } from 'lucide-react';

const AdminBar = () => {
  const [currentUser, setCurrentUser] = React.useState(null);
  const location = useLocation();

  React.useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem('surgedome_current_user'));
      setCurrentUser(user);
    } catch (e) { console.error("Error in AdminBar.jsx:", e); }
  }, []);

  if (currentUser?.role !== 'super_admin') {
    return null;
  }

  const currentPath = location || '';
  const isStaticPage = currentPath.startsWith('/p/');
  const isArticlePage = currentPath !== '/' && !currentPath.startsWith('/admin') && !currentPath.startsWith('/auth') && !currentPath.startsWith('/category') && !currentPath.startsWith('/author') && !currentPath.startsWith('/search') && !currentPath.startsWith('/games') && !currentPath.startsWith('/shopping') && !currentPath.startsWith('/prudentguide');
  const slug = currentPath.split('/').pop();

  return (
    <div className="fixed top-0 left-0 w-full h-10 bg-brand-secondary border-b border-brand-border-alt text-gray-300 z-[9999] flex items-center justify-between px-4 text-xs font-medium">
      <div className="flex items-center gap-6">
        <Link 
          href="/prudentguide" 
          className="flex items-center gap-2 hover:text-white transition-colors"
        >
          <span className="font-bold tracking-widest uppercase text-brand-primary">SURGEDOME</span>
          <LayoutDashboard className="w-3.5 h-3.5" />
          <span>Dashboard</span>
        </Link>
        
        <div className="h-4 w-px bg-gray-700"></div>

        <Link 
          href="/prudentguide/editor" 
          className="flex items-center gap-1.5 hover:text-white transition-colors"
        >
          <Plus className="w-3.5 h-3.5" /> New Article
        </Link>
        
        <Link 
          href="/prudentguide/pages/new" 
          className="flex items-center gap-1.5 hover:text-white transition-colors"
        >
          <Plus className="w-3.5 h-3.5" /> New Page
        </Link>

        {(isStaticPage || isArticlePage) && (
          <>
            <div className="h-4 w-px bg-gray-700"></div>
            <Link 
              href={isStaticPage ? `/prudentguide/pages/edit/${slug}` : `/prudentguide/editor/${slug}`} 
              className="flex items-center gap-1.5 text-brand-primary hover:text-yellow-400 font-bold transition-colors"
            >
              <Edit3 className="w-3.5 h-3.5" /> 
              {isStaticPage ? 'Edit Page' : 'Edit Article'}
            </Link>
          </>
        )}
      </div>

      <div className="flex items-center gap-4">
        <span className="text-brand-muted">Hello, {currentUser.name}</span>
        {currentUser.avatar && (
          <img src={currentUser.avatar} alt="Avatar" className="w-6 h-6 rounded-full object-cover" />
        )}
      </div>
    </div>
  );
};

export default AdminBar;
